import { useEffect } from 'react';
import { Deferred } from '../../concurrency/deferred';
const nextTick = Promise.resolve();
export function useAsyncEffect(effectCallback, deps, preventDuplicatedRun = false) {
    useEffect(() => {
        const mounted = { current: true };
        const effectReleased = new Deferred(true);
        const run = preventDuplicatedRun
            ? async () => {
                await nextTick;
                if (!mounted.current)
                    return;
                return effectCallback(mounted, effectReleased);
            }
            : () => effectCallback(mounted, effectReleased);
        if (typeof setImmediate === 'function') {
            setImmediate(run);
        }
        else {
            setTimeout(run);
        }
        return () => {
            effectReleased.fulfill();
            mounted.current = false;
        };
    }, deps);
}
//# sourceMappingURL=use-async-effect.js.map